/* eslint-disable no-param-reassign */
import React, { useState, useEffect, useMemo } from 'react';
import { useHistory, useLocation, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import './TopNavbar.css';
import { logOut } from '../../../services/auth.service';
import { detachActiveUploads, hasActiveUploads } from '../../../utils/active-uploads-registry';
import { getNotifications } from '../../../services/notification.service';
import { localStorageService } from '../../../services/localStorage.service';
import { toasterMsg } from '../../Toaster/Toaster';
import 'react-perfect-scrollbar/dist/css/styles.css';
import noImage from '../../../assets/images/no-image.png';
import VerticalMenu from '../SubHeader/VerticalMenu';
import { useComponent } from '../../../Pages/UserSetting/UsersLibrary/UserRights';
import * as action from '../../../Pages/UserSetting/store/User.action';
import UserNotification from '../../../Pages/UserNotification';
import NotificationProvider from '../../../Pages/UserNotification/NotificationProvider';
import { fetchNotificationList, updateSocketbasedValue } from '../../../Pages/UserNotification/store/notification.action';
import { useSocketContextState } from '../../../socket';
import { hideImage, RightsAccess, imageUrl } from '../../helper';
import * as actionDevOrder from '../../../Pages/DevlopmentOrder/store/DevelopmentOrder.action';
import documentType from '../../../Pages/UserSetting/store/User.type';
import { getProfileDetails, getSupplierProfileDetails, getUserProfileDetails } from '../../../Pages/UserSetting/store/User.action';
import { fetchProductname } from '../../../Pages/DevlopmentOrder/store/DevelopmentOrder.action';
import MobileNav from './MobileNav';
import { invalidateAllMasters } from '../../../store/master-cache';
import {
  HistoryIcon,
  NotificationBellIcon,
  SettingsIcon,
  LogoutIcon,
  SubmitAndDownloadIcon,
  MoreIcon,
} from '../../../bombiix-icon';

/** Every glyph in the top bar renders at 28px. */
const HEADER_ICON_SIZE = 28;

/**
 * Reports whether a path belongs to the Partner Overview area.
 *
 * The nav item matched `/suppliers` alone, so it un-highlighted as soon as the
 * user moved to a partner's sub-pages (`/supplier/:id/users`) or to a factory
 * (`/factories/edit/:id`) — the header stopped showing where they were. The
 * sub-header already treats `/supplier/` as part of this area; factories are
 * reached only from a partner, so they belong to it too.
 * @param {string} pathName - Current location pathname.
 * @returns {boolean} True when the path sits under Partner Overview.
 */
const isPartnerOverviewPath = (pathName) => pathName.includes('/suppliers') || pathName.includes('/supplier/') || pathName.includes('/factories');

function MainNabBar() {
  const devOrderReducer = useSelector((reducerstate) => reducerstate);
  const { t, i18n } = useTranslation('common');
  const colourLibraryPath = '/libraries/colour-library';
  const bomtypeLibraryPath = '/libraries/bom-type';
  const patternLibraryPath = '/libraries/pattern';
  const careLibraryPath = '/libraries/care/symbol';
  const costingTemplatePath = '/libraries/costing-template';
  const poLibraryPath = '/libraries/po-template';
  const pomGradingPath = '/libraries/point-of-measures';
  const specTemplatePath = '/libraries/spec-template';
  const testingAccessPath = '/libraries/testing';
  const developmentOrderOverviewPath = '/development-order-overview';
  const topNavbarLogout = 'TOP_NAVBAR.LOG_OUT';
  const btnNavActiveClass = 'btn-nav active';
  const supplierSuggestionPath = '/supplier-suggestion';
  const submitDownloadPath = '/submit-download-history';
  const developmentOrderPath = '/development-order';
  const manualDocumentPath = '/documents';
  const retailIdentifierPath = '/libraries/retail-identifier';

  const {
    Users: { logInRights, moduleAccess, sectionAccess, subscriptionDetails, profileDetails },
    UserNotificationDetails: { totolCount },
    UserDetails: { isCompanyAdminLoggedIn, userInfo, isSupplierLoggedIn },
    BOMConfigDetails: { productDetails },
  } = devOrderReducer;
  const { reportsRight, suggestionRight, componentOrderRight, manualDocsRight, DAMRight, PIMRight } = RightsAccess();
  const { socketState } = useSocketContextState();
  const [state, setState] = useState({
    mastersAccess: true,
    librariesAccess: true,
    productsAccess: true,
    supplierOverviewAccess: true,
    manualsAccess: true,
    planningAccess: false,
    placeholderAccess: false,
    rangePlanAccess: false,
    criticalPathAccess: false,
    activeSubmenu: '',
    isNotificationOpen: false,
  });
  const {
    mastersAccess,
    librariesAccess,
    productsAccess,
    manualsAccess,
    supplierOverviewAccess,

    isNotificationOpen,
  } = state;
  const handleClickOutside = (event) => {
    if (event.target.tagName !== 'IMG') {
      hideImage();
    }
  };
  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);
  useEffect(() => {
    if (!isEmpty(moduleAccess)) {
      setState((prev) => ({
        ...prev,
        ...moduleAccess,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moduleAccess]);

  const history = useHistory();
  const pathName = history.location.pathname;
  const [toggleSubMenu, setToggleSubMenu] = useState(false);
  const [profileMenu, setProfileMenu] = useState(false);
  const [mainMenu, setMainMenu] = useState(false);

  const [notificationCount, setNotificationCount] = useState(0);
  const host = window.location.origin;
  const [companyImage, setCompanyImage] = useState(noImage);
  const { search } = useLocation();
  const location = useLocation();
  const queryParams = new URLSearchParams(search);
  const queryDevOrderId = queryParams.get('devOrderId');
  const queryCostingId = queryParams.get('costingId');
  const querySupplierId = queryParams.get('supplierId');
  const [userRights, setUserRights] = useState({});
  const dispatch = useDispatch();
  const devOrderId = pathName.match(/\/development-order\/([0-9a-f]{24})/i)?.[1];
  const isProductOverviewRoute = pathName.startsWith(developmentOrderOverviewPath);
  const isProductDetailRoute = pathName.startsWith(developmentOrderPath) && !isProductOverviewRoute;
  const { createConditionalComponent } = useComponent();
  const isCompanyUser = userInfo.role === 'User';
  const [supplierPermission, setSupplierPermission] = useState(false);
  const supplierUserId = userInfo?.supplierUserId;
  useEffect(() => {
    // Update state when the route changes
    setProfileMenu(false);
    setMainMenu(false);
  }, [location]);
  useEffect(() => {
    if (profileDetails?.language) {
      i18n.changeLanguage(profileDetails?.language);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileDetails]);

  useEffect(() => {
    if (!userInfo?.role) return;
    const fetch = async () => {
      const fetchAdminUserDetails = async () => {
        await dispatch(getProfileDetails({ id: userInfo?.userId }));
      };

      const supplierDetails = async () => {
        await dispatch(getSupplierProfileDetails({ supplierId: userInfo?.userId }));
      };

      const supplierUserDetails = async () => {
        await dispatch(getUserProfileDetails({ id: supplierUserId }));
      };

      const companyUserDetails = async () => {
        await dispatch(getUserProfileDetails({ id: userInfo?.userId }));
      };

      switch (userInfo?.role) {
        case 'Admin':
          fetchAdminUserDetails();
          break;

        case 'Supplier':
          if (supplierUserId) {
            supplierUserDetails();
          } else {
            supplierDetails();
          }
          break;

        case 'User':
          companyUserDetails();
          break;

        default:
          break;
      }
    };
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, userInfo?.userId, userInfo?.role, supplierUserId]);

  const getSupplierPermission = async () => {
    const supplierData = await dispatch(action.fetchSupplierPermissionService());
    setSupplierPermission(supplierData?.companies[0]?.canSuggest);
  };

  useEffect(() => {
    const payload = {
      section: 'all',
    };
    if (!isCompanyAdminLoggedIn) {
      dispatch(action.fetchLogInRights(payload));
    }
    if (isCompanyAdminLoggedIn) {
      dispatch({
        type: documentType.ADMIN_RIGHTS_ACCESS,
      });
    }

    if (isSupplierLoggedIn) {
      getSupplierPermission();
    }
  }, []);

  useEffect(() => {
    if (logInRights) {
      setUserRights(logInRights);
    }
  }, [logInRights]);

  const SupplierOverviewAccess = createConditionalComponent(userRights, 'supplierOverview');

  /**
   * Resolves the header's company logo.
   *
   * `userInfo` is the `loggedInUserInfo` snapshot taken at login and never refreshed, so a logo
   * changed in super-admin stayed stale until the user signed in again. `profileDetails` is fetched
   * from the server on mount by the effect above, so it is preferred when present and the cached
   * snapshot is healed from it; `userInfo` remains the fallback for roles whose profile payload
   * carries no companyLogo.
   */
  useEffect(() => {
    const logo = profileDetails?.companyLogo || userInfo?.companyLogo;
    if (logo === '' || logo === null || logo === undefined) {
      return;
    }
    if (profileDetails?.companyLogo && profileDetails.companyLogo !== userInfo?.companyLogo) {
      const cachedUserInfo = localStorageService.get('loggedInUserInfo');
      if (cachedUserInfo) {
        cachedUserInfo.companyLogo = profileDetails.companyLogo;
        localStorageService.set('loggedInUserInfo', cachedUserInfo);
      }
    }
    if (logo.includes('super-admin')) {
      setCompanyImage(`https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${logo}`);
    } else if (logo.includes('s3.eu-west-2')) {
      setCompanyImage(logo);
    } else if (logo.startsWith('http') && logo.startsWith('https')) {
      const href = new URL(logo);
      setCompanyImage(`${imageUrl}${href.pathname}`);
    } else {
      setCompanyImage(`${imageUrl}/${logo}`);
    }
  }, [userInfo, profileDetails, host, productDetails, pathName]);

  useEffect(() => {
    const fetchCustomModuleMenu = async () => {
      const obj = {
        devOrderId,
        isActive: true,
      };

      await dispatch(actionDevOrder.getCustomModuleList(obj));
      await dispatch(actionDevOrder.getdppModuleList({ devOrderId }));
    };
    if (pathName.indexOf('/development-order/') > -1 && devOrderId) {
      fetchCustomModuleMenu();
      dispatch(fetchProductname(devOrderId));
    }
  }, [devOrderId]);

  const logout = async () => {
    /**
     * Stop sending parts before the session ends, but deliberately do NOT abort the S3 uploads:
     * detaching keeps the already-uploaded parts and their pending records, so the user is offered
     * a resume next time they log in. The short wait lets the in-flight requests unwind before the
     * session cookie goes away.
     */
    if (hasActiveUploads()) {
      detachActiveUploads();
      await new Promise((resolve) => setTimeout(resolve, 500));
    }
    await logOut();
    /* Master lists are scoped to the signed-in user's assignments, so their freshness must not
       survive into the next session in this tab. */
    invalidateAllMasters();
    localStorageService.remove('loggedInUserInfo');
    localStorageService.remove('previousStates');
    localStorageService.remove('PO_Filters');
    localStorageService.remove('planningFilter');
    localStorageService.remove('bottomUpFilter');
    localStorageService.remove('costingTodoListFilter');
    localStorageService.remove('sampleTodoListFilter');
    localStorageService.remove('indicatorTodoListFilter');
    localStorageService.remove('poTodoListFilter');
    localStorageService.remove('todo_po_selected_options');
    localStorageService.remove('submitTodoListFilter');
    localStorageService.remove('suggestionTodoListFilter');
    localStorageService.remove('productListFilter');
    localStorageService.remove('libraryBOMFilter');
    localStorageService.remove('rememberMe');
    localStorageService.remove('cmLibraryData');
    localStorageService.remove('cmProductData');

    toasterMsg('You have successfully logged out', 'success');
    window.location.assign(`${window.location.origin}/login`);
  };

  const handleCompanyuser = () => {
    const submitTechPackRights = userRights?.length > 0 ? userRights?.map((ele) => ele.submitTechPack) : [];
    const downloadTechPackRights = userRights?.length > 0 ? userRights?.map((ele) => ele?.downloadTechPack) : [];
    const submitTechPackRight = submitTechPackRights?.includes(true);
    const downloadTechPackRight = downloadTechPackRights?.includes(true);
    return submitTechPackRight || downloadTechPackRight
      ? `/development-order/${devOrderId}/submit-download`
      : `/development-order/${devOrderId}/submit-download-logs`;
  };

  const hideShowSubMenu = () => {
    setToggleSubMenu(!toggleSubMenu);
  };

  const getNotificationList = async () => {
    const notificationObj = await getNotifications();
    if (notificationObj?.data && notificationObj.data.count) {
      setNotificationCount(notificationObj.data.count);
    }
  };

  const getUserNotificationList = async () => {
    const reqObj = {
      pageIndex: 1,
      pageSize: 20,
    };
    dispatch(fetchNotificationList(reqObj, t));
  };

  useEffect(() => {
    async function fetchData() {
      // You can await here
      await getNotificationList();
      await getUserNotificationList();
    }
    fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const checkModulePermission = (permission) => subscriptionDetails?.modules?.[permission] === true || false;

  const isGlobalUrl = querySupplierId && queryDevOrderId && queryCostingId && pathName.includes('product-costing-supplier');

  useEffect(() => {
    // Listen for a custom event from the server
    if (socketState?.socketContext) {
      socketState?.socketContext?.on(t('TOP_NAVBAR.SEND_USER_NOTIFICATION'), function (data) {
        dispatch(updateSocketbasedValue(data));
      });

      socketState?.socketContext?.on('send notification msg', function (company) {
        console.log('[Notification] 🔔 Received notification refresh trigger:', {
          company,
          timestamp: new Date().toISOString(),
        });
        try {
          getNotificationList();
          getUserNotificationList();
        } catch (error) {
          console.error('[Notification] ❌ Error refreshing notifications:', error);
        }
      });
    }
    if (socketState?.socketContext) {
      socketState?.socketContext?.on(t('TOP_NAVBAR.USER_RIGHTS_LISTENER'), function (data) {
        const payload = {
          section: 'all',
        };
        if (!isCompanyAdminLoggedIn) {
          dispatch(action.greeedyMenuLoader(true));
          dispatch(action.fetchLogInRights(payload));
        }
      });
    }
    // Clean up the event listener when the component unmounts
    return () => {
      if (socketState?.socketContext) {
        socketState?.socketContext?.off(t('TOP_NAVBAR.SEND_USER_NOTIFICATION'));
        socketState?.socketContext?.off('send notification msg');
        socketState?.socketContext?.off(t('TOP_NAVBAR.USER_RIGHTS_LISTENER'));
      }
    };
  }, [dispatch, socketState?.socketContext]);

  const redirectUrls = useMemo(() => {
    const redirectObj = {
      coloursAccess: colourLibraryPath,
      bomAccess: bomtypeLibraryPath,
      cadAccess: patternLibraryPath,
      careAccess: careLibraryPath,
      costingTemplateAccess: costingTemplatePath,
      poTemplateAccess: poLibraryPath,
      pomGradingAccess: pomGradingPath,
      specAccess: specTemplatePath,
      testingAccess: testingAccessPath,
      retailIdentifierAccess: retailIdentifierPath,
    };

    let redirectUrl;
    if (!isCompanyAdminLoggedIn) {
      for (const key in sectionAccess?.libraries) {
        if (sectionAccess?.libraries[key] && redirectObj[key]) {
          redirectUrl = redirectObj[key];
          break; // Stop iterating as soon as the first true value is found
        }
      }
    } else {
      redirectUrl = colourLibraryPath;
    }
    return redirectUrl;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectionAccess?.libraries]);

  const toggleMenu = () => {
    setProfileMenu(!profileMenu);
  };
  const toggleMainMenu = () => {
    setMainMenu(!mainMenu);
  };
  const getPageTitle = () => {
    switch (true) {
      case pathName.includes('/development-order-overview'):
      case pathName.includes('/planning/planning-actual'):
      case pathName.includes('/placeholder-management'):
      case pathName.includes('/rangeplan/'):
      case pathName.includes('/range-plan/'):
      case pathName.includes('/operational-cp'):
      case pathName.includes('/development-order/'):
        return 'Product Information';
      case pathName.includes('/todo-list/'):
        return '';
      case pathName.includes('/pim-v2'):
        return 'PIM';
      case pathName.includes('/digital-assets-management'):
        return 'Dam';
      case pathName.includes('/component-order/'):
        return 'Component Orders';
      case pathName.includes('/libraries/'):
        return 'Libraries/Groups/Templates';
      case isPartnerOverviewPath(pathName):
        return 'Partner Overview';
      case pathName.includes('/supplier-suggestion'):
        return 'Supplier Suggestions';
      case pathName.includes('/documents'):
        return 'Manuals/Documents';
      default:
        break;
    }
  };
  return (
    <>
      <div className={`header ${isGlobalUrl ? 'd-none' : ''}`}>
        <div className="main-navigation">
          <div className="nav">
            <button type="button" onClick={toggleMainMenu} className="btn btn-main-menu" aria-label="Menu">
              {mainMenu ? <i className="icon-Close-Mobile-1 f-32" /> : <i className="icon-Minus f-32" />}
            </button>
            {pathName.includes('/development-order/') && (
              <Link className="menu-back-btn" to="/development-order-overview">
                <span className="icon icon-Table-Down-1 f-24" />
              </Link>
            )}
            <span className="main-nav-title">{getPageTitle()}</span>
            {mainMenu && (
              <MobileNav
                mastersAccess={mastersAccess}
                mainMenu
                reportsRight
                pathName={pathName}
                productsAccess={productsAccess}
                moduleAccess={moduleAccess}
                isSupplierLoggedIn={isSupplierLoggedIn}
                PIMRight
                checkModulePermission={checkModulePermission}
                manualsAccess
                manualDocsRight
                componentOrderRight
                DAMRight
                librariesAccess
                suggestionRight
                supplierPermission
                t={t}
                productDetails={productDetails}
                createConditionalComponent={createConditionalComponent}
                userRights={userRights}
              />
            )}

            <ul className="nav-ul">
              {reportsRight && moduleAccess?.productsAccess && (
                <li>
                  <Link className={pathName.includes('/todo-list') ? btnNavActiveClass : 'btn-nav'} to="/todo-list/my-todo">
                    {t('TOP_NAVBAR.REPORTS')}
                  </Link>
                </li>
              )}

              {productsAccess && (
                <>
                  <li>
                    <Link
                      className={
                        [
                          '/development-order-overview',
                          '/rangeplan/product-list',
                          '/operational-cp',
                          '/product-cp',
                          '/placeholder-management',
                          '/planning/planning-actual',
                          '/range-plan/logs',
                        ].some((route) => pathName.startsWith(route))
                          ? btnNavActiveClass
                          : 'btn-nav'
                      }
                      to="/development-order-overview"
                    >
                      {t('TOP_NAVBAR.PRODUCT_INFORMATION')}
                    </Link>
                  </li>

                  {moduleAccess?.pimAccess && !isSupplierLoggedIn && PIMRight && (
                    <li>
                      <Link className={`${pathName.includes('pim-v2') && 'active'}`} to="/pim-v2/templates">
                        {t('PLACEHOLDER_URL.PIM')}
                      </Link>
                    </li>
                  )}

                  {moduleAccess?.damAccess && DAMRight && !isSupplierLoggedIn && (
                    <li>
                      <Link
                        className={
                          [
                            '/digital-assets-management',
                            '/digital-assets-management/folder',
                            '/digital-assets-management/history',
                            '/digital-assets-management/add',
                            '/digital-assets-management/edit',
                            'digital-assets-management/folder/edit',
                            'digital-assets-management/folder/add',
                          ]?.some((path) => pathName?.startsWith(path))
                            ? btnNavActiveClass
                            : 'btn-nav'
                        }
                        to="/digital-assets-management"
                      >
                        {t('TOP_NAVBAR.DAM')}
                      </Link>
                    </li>
                  )}

                  {!isSupplierLoggedIn && checkModulePermission('componentOrder') && componentOrderRight && (
                    <li>
                      <Link className={pathName.includes('/component-order/') ? btnNavActiveClass : 'btn-nav'} to="/component-order/purchase-order">
                        {t('TOP_NAVBAR.COMPONENT_ORDERS')}
                      </Link>
                    </li>
                  )}
                </>
              )}

              {!isSupplierLoggedIn && librariesAccess && (
                <li>
                  <Link className={pathName.includes('/libraries/') ? btnNavActiveClass : 'btn-nav'} to={redirectUrls}>
                    <span className="web-text">{t('TOP_NAVBAR.LIBRARIES_GROUP')}</span>
                    <span className="mobile-text">{t('TOP_NAVBAR.LIBRARIES_GROUP_MOBILE')}</span>
                  </Link>
                </li>
              )}
              {!isSupplierLoggedIn && supplierOverviewAccess && (
                <SupplierOverviewAccess>
                  <li>
                    <Link className={isPartnerOverviewPath(pathName) ? btnNavActiveClass : 'btn-nav'} to="/suppliers">
                      {t('navbar.menu5')}
                    </Link>
                  </li>
                </SupplierOverviewAccess>
              )}

              {!isSupplierLoggedIn && suggestionRight && (
                <li>
                  <Link className={pathName.indexOf(supplierSuggestionPath) > -1 ? btnNavActiveClass : 'btn-nav'} to={supplierSuggestionPath}>
                    {t('TOP_NAVBAR.SUPLIER_SUGGESTION')}
                  </Link>
                </li>
              )}
              {isSupplierLoggedIn && suggestionRight && supplierPermission && (
                <li>
                  <Link className={pathName.indexOf(supplierSuggestionPath) > -1 ? btnNavActiveClass : 'btn-nav'} to={supplierSuggestionPath}>
                    {t('TOP_NAVBAR.SUPLIER_SUGGESTION')}
                  </Link>
                </li>
              )}

              {manualsAccess && manualDocsRight && (
                <li>
                  <Link className={pathName.indexOf(manualDocumentPath) > -1 ? btnNavActiveClass : 'btn-nav'} to={manualDocumentPath}>
                    {t('TOP_NAVBAR.MANUAL_DOCUMENT')}
                  </Link>
                </li>
              )}
              {!isSupplierLoggedIn && mastersAccess && (
                <li>
                  <Link className={pathName.indexOf('/masters') > -1 ? btnNavActiveClass : 'btn-nav'} to="/masters">
                    {t('TOP_NAVBAR.SYSTEM_MASTER')}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          <div className="profile-info">
            <button type="button" onClick={toggleMenu} className="btn btn-profile-more" aria-label="More">
              <MoreIcon size={28} />
            </button>
            <ul className={`profile-ul ${profileMenu && 'open'}`}>
              {isProductDetailRoute && !isSupplierLoggedIn && (
                <li>
                  <Link className="icon-button" title={t('TOP_NAVBAR.HISTORY')} to={`/development-order/${devOrderId}/history`}>
                    <HistoryIcon size={HEADER_ICON_SIZE} />
                    <span className="mobile-title">History</span>
                  </Link>
                </li>
              )}

              {!isSupplierLoggedIn && isProductDetailRoute && (
                <li>
                  <Link
                    className="icon-button"
                    title={t('TOP_NAVBAR.SUBMIT_DOWNLOADS')}
                    to={isCompanyUser ? handleCompanyuser() : `/development-order/${devOrderId}/submit-download`}
                  >
                    <SubmitAndDownloadIcon size={HEADER_ICON_SIZE} />
                    <span className="mobile-title">Submit/Download</span>
                  </Link>
                </li>
              )}

              {(isProductOverviewRoute || !pathName.startsWith(developmentOrderPath)) && !isSupplierLoggedIn && (
                <li>
                  <Link className="icon-button" title={t('TOP_NAVBAR.DOWNLOAD_HISTORY')} to={submitDownloadPath}>
                    <HistoryIcon size={HEADER_ICON_SIZE} />
                    <span className="mobile-title">Submit/Download History</span>
                  </Link>
                </li>
              )}

              {isSupplierLoggedIn && isProductDetailRoute && (
                <li>
                  <Link className="icon-button" title={t('TOP_NAVBAR.DOWNLOAD_ACCESS')} to={`/development-order/${devOrderId}/submit-download-logs`}>
                    <SubmitAndDownloadIcon size={HEADER_ICON_SIZE} />
                    <span className="mobile-title">Submit/Download History</span>
                  </Link>
                </li>
              )}

              <li>
                <button
                  type="button"
                  className="icon-button"
                  title="Notifications"
                  onClick={() => {
                    setState((prev) => ({
                      ...prev,
                      isNotificationOpen: true,
                    }));
                  }}
                >
                  <div className="position-relative d-flex align-items-center">
                    <NotificationBellIcon size={HEADER_ICON_SIZE} />
                    {totolCount > 0 && totolCount < 100 && <span className="badge badge-notification">{totolCount}</span>}
                    {totolCount !== 0 && totolCount > 100 ? (
                      <span className="badge badge-notification" title={totolCount}>
                        99+
                      </span>
                    ) : (
                      <span />
                    )}

                    <span className="mobile-title">Notifications</span>
                  </div>
                </button>
              </li>
              <li>
                <Link className="icon-button" title={t('TOP_NAVBAR.SETTINGS')} to="/settings/account-details">
                  <SettingsIcon size={HEADER_ICON_SIZE} />
                  <span className="mobile-title">Settings</span>
                </Link>
              </li>
              <li>
                <button
                  type="button"
                  className="icon-button"
                  title={t(topNavbarLogout)}
                  aria-label={t(topNavbarLogout)}
                  onClick={() => {
                    logout();
                  }}
                >
                  <LogoutIcon size={HEADER_ICON_SIZE} />
                  <span className="mobile-title">Logout</span>
                </button>
              </li>
            </ul>
            {profileDetails?.image ? (
              <img
                src={`${profileDetails?.image}`}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null;
                  currentTarget.src = noImage;
                }}
                className="user-name"
                alt="images"
                width="80"
                height="80"
              />
            ) : (
              <p className="user-name m-0 text-truncate" title={`${userInfo.firstName} ${userInfo.lastName}`}>
                {`${userInfo.firstName[0]}${userInfo.lastName[0]}`}
              </p>
            )}
          </div>
        </div>
        <div className="vertical-navbar">
          <div className="company-logo">
            <img
              className="logo"
              src={companyImage}
              alt="Company Logo"
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = noImage;
              }}
            />
            <div className="hover-logo">
              <img className="logo" src={companyImage} alt="Company Logo" />
            </div>
          </div>
          <VerticalMenu productDetails={productDetails} hideShowSubMenu={hideShowSubMenu} imageWidth={72} />
          <div className="plm-logo" title="Bombiix PLM">
            <i className="icon-PLM-new-logo" />
          </div>
        </div>
      </div>
      {isNotificationOpen && (
        <NotificationProvider>
          <UserNotification
            updateNotificationCount={getNotificationList}
            oldNotificationCount={notificationCount}
            userInfo={userInfo}
            isShow={isNotificationOpen}
            closeNotification={() =>
              setState((prev) => ({
                ...prev,
                isNotificationOpen: false,
              }))
            }
          />
        </NotificationProvider>
      )}
    </>
  );
}

export default MainNabBar;
